export default [
  {
    category: 'basics',
    element: 'text',
    title: 'Text',
    icon: 'far fa-text-size fa-fw',
    description: 'Add editable text.',
    test: 'text',
  },
  {
    category: 'basics',
    element: 'oval',
    title: 'Oval',
    icon: 'fas fa-circle fa-fw',
    description: 'Circle shape.',
    test: 'oval',
  },
  {
    category: 'basics',
    element: 'rectangle',
    title: 'Rectangle',
    icon: 'fas fa-square fa-fw',
    description: 'Rectangle shape.',
    test: 'rectangle',
  },
  {
    category: 'basics',
    element: 'triangle',
    title: 'Triangle',
    icon: 'fas fa-triangle fa-fw',
    description: 'Triangle shape.',
    test: 'triangle',
  },
  {
    category: 'basics',
    element: 'image',
    title: 'Image',
    icon: 'far fa-image fa-fw',
    description: 'Display an image.',
    test: 'image',
  },
  {
    category: 'basics',
    element: 'video',
    title: 'Video',
    icon: 'far fa-video fa-fw',
    description: 'Embed a video.',
    test: 'video',
  },
  {
    category: 'basics',
    element: 'date',
    title: 'Date/Time',
    icon: 'far fa-clock fa-fw',
    description: 'Show date and time.',
    test: 'date',
  },
  {
    category: 'basics',
    element: 'timer',
    key: 'timer-countdown',
    title: 'Countdown',
    icon: 'far fa-hourglass fa-fw',
    description: 'Count down to a date/time, or from a set duration.',
    test: 'timer-countdown',
    settings: {
      timerType: 'Countdown',
    },
  },
  {
    category: 'basics',
    element: 'timer',
    key: 'timer-stopwatch',
    title: 'Stopwatch',
    icon: 'far fa-stopwatch fa-fw',
    description: 'A running timer that counts up in real time.',
    test: 'timer-stopwatch',
    settings: {
      timerType: 'Count Up',
    },
  },
];
